// STYLES
import * as Style from "./LanguageStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";
import i18n from "config/translate";

// MISC
import { IProps } from "./LanguageModel";

// ASSETS
import RomanianIcon from "assets/Icons/RomanianIcon.png";
import EnglishIcon from "assets/Icons/EnglishIcon.png";

// REDUX
// COMPONENTS

const Language = (props: IProps) => {
  // PROPS
  const { handleClose = () => {} } = props;

  // CONSTANTS USING LIBRARIES
  const { t } = useTranslation();

  // CONSTANTS USING HOOKS

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleChangeLanguageToRomanian = () => {
    i18n.changeLanguage("ro");
  };
  const handleChangeLanguageToEnglish = () => {
    i18n.changeLanguage("en");
  };

  return (
    <Style.LanguageContainer>
      <Style.CloseIconContainer>
        <Style.CloseIcon onClick={handleClose} />
      </Style.CloseIconContainer>
      <Style.Title>{t("modal.language.title")}</Style.Title>
      <Style.Bar />
      <Style.LanguageType onClick={handleChangeLanguageToRomanian}>
        <Style.LanguageFlagIcon src={RomanianIcon} />
        <Style.LanguageName>{t("modal.language.romanian")}</Style.LanguageName>
      </Style.LanguageType>
      <Style.Bar />
      <Style.LanguageType onClick={handleChangeLanguageToEnglish}>
        <Style.LanguageFlagIcon src={EnglishIcon} />
        <Style.LanguageName>{t("modal.language.english")}</Style.LanguageName>
      </Style.LanguageType>
    </Style.LanguageContainer>
  );
};

export default Language;
